import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { ISendOtpLoginLinkRequestDto } from '~/@api/generated-api-types-user/Api'
import { getErrorMessage } from '~/@lib/utils/error.utils'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'

export type SendSmsLoginRedirectLinkData = Omit<
  ISendOtpLoginLinkRequestDto,
  'redirectUrl'
>

function useSendSmsLoginLink(redirectUrl?: string) {
  const client = useApiClientUser()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const { setNotification } = useLocalNotifications()
  const mutation = useMutation({
    mutationFn: async (data?: SendSmsLoginRedirectLinkData) => {
      const response = await client.user
        .userOtpControllerSendOtpLoginLink({
          redirectUrl,
          ...(data ? data : {}),
        })
        .then((response) => response.data)
      return response
    },
    onSuccess: (resp) => {
      setIsDialogOpen(true)
      if (!resp.reused)
        setNotification('success', resp.message ?? 'SMS odkaz bol odoslaný.')
    },
    onError: (error) => {
      setNotification(
        'error',
        getErrorMessage(error) ?? 'SMS odkaz sa nepodarilo odoslať.'
      )
    },
  })
  return {
    mutate: (data?: SendSmsLoginRedirectLinkData) => mutation.mutate(data),
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    twoFaCodeExpiresAt: mutation.data?.expiresAt
      ? new Date(mutation.data.expiresAt)
      : null,
    isDialogOpen,
    setIsDialogOpen,
  }
}

export { useSendSmsLoginLink }
